/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import AddRemoveJadwal from './AddRemoveJadwal'
import {
  getKontrakDetails,
  getAccesses,
  getSipDetail,
  resubmitContract,
} from '../../../api/modules/kontrak'
import axios from 'axios'
import swal from 'sweetalert'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import i18next from 'i18next'
import {Spinner} from 'react-bootstrap'
import Select from 'react-select'
import {
  getIncoterm,
  getCountryList,
  getProvince3,
  getFooterContent,
} from '../../../api/modules/getdatalist'
import CustomUseEffect from './CustomUseEffect'
import {
  getSalesAreaKontrak,
  getFilterCity,
  getCusGrup,
  getAccAss,
} from '../../../api/modules/master-data/master_2'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {Link, useNavigate, useParams} from 'react-router-dom'
import InputGroup from 'react-bootstrap/InputGroup'
import {PopoverText} from '../../../components/Popover/Popover'
import {useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {ModalAddItem} from './components/ModalAddItem'
import {id} from 'date-fns/locale'
import {ModalEditItem} from './components/ModalEditItem'
import {TableBrowseCustomer} from './TableBrowseCustomer'
import {getCustomer} from 'src/api/modules/findoc'

import {contractSelector} from '../../../redux/slices/contractSlices'
import { AdditionalTextModal } from './components/AdditionalText'
import { getDetailFileConfig } from 'src/api/modules/master-data/master'
import ViewLetter from 'src/components/Letter/ViewLetter'
import { AttachhmentModal } from './components/AttachhmentModal'
import { ModalAddProduct } from './components/ModalAddProduct'
import { ScheduleModal } from './components/ScheduleModal'

const KontrakRevisi: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const {roleId} = useAppSelector(authSelector)

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const params = useParams()

  const {t} = useTranslation()

  const [loadingPage, setLoadingPage] = useState(false)
  const [detail, setDetail] = useState<any>()
  const [sipNum, setSipNum] = useState(false)
  const [accesses, setAccesses] = useState<any>()

  const [customerId, setCustomerId] = useState('')
  const [validateTo, setValidateTo] = useState<any>()
  const [validateFrom, setValidateFrom] = useState<any>()
  const [assignerName, setassignerName] = useState('')
  const [assignerPos, setassignerPos] = useState('')
  const [fixedPrice, setFixedPrice] = useState<any>()
  const [quantumApprove, setQuantumApprove] = useState<any>()
  const [sackApprove, setSackApprove] = useState<any>()
  const [sackUnit, setSackUnit] = useState<any>()
  const [beforePpn, setBeforePpn] = useState<any>()
  const [btnLoading, setBtnLoading] = useState(false)
  const [fullIncoterm, setFullIncoterm] = useState<any[]>([])
  const [incoterm, setIncoterm] = useState<any>()
  const [incoterm2, setIncoterm2] = useState('')
  const [salesOrg, setSalesOrg] = useState('')
  const [distChanel, setDistChanel] = useState('')
  const [sales_office, setSalesOffice] = useState('')
  const [sektorid, setsektorid] = useState(0)
  const [cusName, setCusName] = useState<any>('')
  const [cusTitle, setCusTitle] = useState<any>('')
  const [customerShipCode, setCustomerShipCode] = useState<any>('')
  const [customerShipName, setCustomerShipName] = useState<any>('')
  const [countryId, setCountryId] = useState<any>('')
  const [countryDesc, setCountryDesc] = useState<any>('')
  const [province, setProvince] = useState<any>('')
  const [province_desc, setProvinceDesc] = useState<any>('')
  const [doc_is_inc_ppn, setDocIsIncPpn] = useState(true)
  const [additionalText, setAdditionalText] = useState<any>({})

  const [showLetter, setShowLetter] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [showCustomerList, setShowCustomerList] = useState(false)
  const [showUpload, setShowUpload] = useState(false)

  const [numberURLCustomerList, setNumberURLCustomerList] = useState([])
  const [customerLoad, setCustomerLoad] = useState(false)
  const {customerFilter} = useAppSelector(contractSelector)

  const [cityKontrak, setCityKontrak] = useState<any[]>([])
  const [customerList, setCustomerList] = useState<any[]>([])
  const [salesArea, setSalesArea] = useState<any[]>([])
  const [countryList, setCountryList] = useState<any[]>([])
  const [provinceList, setProvinceList] = useState<any[]>([])

  const [cityData, setCityData] = useState<any>()
  const [custAdd, setCustAdd] = useState<any>()
  const [accAdd, setAccAdd] = useState<any>()
  const [showJadwal, setShowJadwal] = useState(false)
  const [showJadwal2, setShowJadwal2] = useState(false)
  const [jadwalID, setJadwalID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [SIPItems, setSIPItems] = useState<any[]>([])
  const [kontrakSub, setKontrakSub] = useState<any[]>([])
  const [itemEditing, setItemEditing] = useState<any>()
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()
  const [userDetail, setUserDetail] = useState<any>()
  const [footer, setFooter] = useState<any>()
  const [PPh22, setPPh22] = useState(false)
  const [attachmentType, setAttachmentType] = useState('order-item')
  const [subOrderID, setSubOrderID] = useState<any>(null)
  const ContractID = params?.id || sessionStorage.getItem('kid')

  useEffect(() => {
    const getDetails = async () => {
      setLoadingPage(true)

      const res = await getKontrakDetails(
        ContractID,
        localStorage.getItem('credential')
      )

      setLoadingPage(false)

      const data = res.data.data
      const sip_order = data.sip_order

      setDetail(data)
      setIncoterm(res.data.data.incoterm1_id)
      setIncoterm2(res.data.data.incoterm2_id)
      setCustomerId(res.data.data?.customer_id)
      setValidateTo(res.data.data?.validity_date_to.slice(0, 10))
      setValidateFrom(res.data.data?.validity_date_from.slice(0, 10))
      setSalesOrg(data.sales_org_code)
      setDistChanel(data.sip_order?.pengajuan_order?.distribution_channel)
      setSalesOffice(data?.sales_office)
      setCityData(data?.sales_group_detail?.id)
      setCustAdd(data?.customer_account_group)
      setAccAdd(data?.account_assignment_group)
      setassignerName(data?.assigner_name)
      setassignerPos(data?.assigner_position)
      setQuantumApprove(data.detail_quantity?.total_tonnase)
      setSackApprove(data.detail_quantity?.total_pcs)
      setsektorid(data.sector_id)
      setCusName(data.customer.name)
      setCusTitle(data.customer.title)
      setCustomerShipCode(data.customer_ship_to)
      setCustomerShipName(data.customer_ship?.name)
      setCountryId(data.country_destination_code)
      setCountryDesc(data.country_destination)
      setProvince(data.province)
      setProvinceDesc(data.province_desc)
      setDocIsIncPpn(data.doc_is_inc_ppn)
      setPPh22(data.amount_of_pph22)
      setAdditionalText({
        title: data.additional_texts?.title,
        customer_pic_name: data.additional_texts?.customer_pic_name,
        customer_pic_position: data.additional_texts?.customer_pic_position,
        terms_and_conditions: data.additional_texts?.terms_and_conditions,
        mail_body: data.additional_texts?.mail_body || 'Bersama ini kami sampaikan persetujuan pembelian dengan rincian sebagai berikut:',
        customer_attn: data.additional_texts?.customer_attn,
        port_of_discharge: data.additional_texts?.port_of_discharge,
        lain_lain: data.additional_texts?.lain_lain,
        keterangan: data.additional_texts?.keterangan,
        text_penutup: data.additional_texts?.text_penutup,
        no_izin_export: data.additional_texts?.no_izin_export,
        title_en: data.additional_texts?.title_en,
        mail_body_en: data.additional_texts?.mail_body_en || 'We hereby convey the purchase agreement with the following details:',
        customer_attn_en: data.additional_texts?.customer_attn_en,
        text_penutup_en: data.additional_texts?.text_penutup_en,
        lain_lain_en: data.additional_texts?.lain_lain_en,
        keterangan_en: data.additional_texts?.keterangan_en,
        terms_and_conditions_en: data.additional_texts?.terms_and_conditions_en,
      })
      setSackUnit(res.data.data.order_sub_details?.[0]?.unit)

      getImg(data.sales_org_code)

      setKontrakSub(
        res.data.data.order_sub_details.map((item: any) => {
          const sip_items = sip_order.order_sub_details
          const sip_item = sip_items[sip_items.findIndex((osd: any) => osd.id == item.sip_item_id)]
          return {
            ...item,
            is_new_item: !sip_item,
            fixed_quantum: parseFloat(sip_item?.fixed_quantum) || parseFloat(item.fixed_quantum),
            fixed_price: sip_item?.fixed_price || item.fixed_price,
            quantum_contract: sip_item ? (parseFloat(sip_item?.quantum_contract) - parseFloat(item.quantum_contract)) : parseFloat(item.quantum_contract),
            quantum: parseFloat(item.fixed_quantum),
            price: item.fixed_price,
          }
        })
      )
    }

    getDetails()
    getSIPDetail()
  }, [])

  const getSIPDetail = async () => {
    const res = await getSipDetail(detail?.sip_order_id, localStorage.getItem('credential'))
    const currentOSDSIP = detail.order_sub_details.map((item: any) => item.sip_item_id)
    const osdSIP = res?.data?.data?.order_sub_details || []
    setSIPItems(osdSIP.filter((item: any) => !currentOSDSIP.includes(item.id)))
  }

  const removeItem = async (item: any, index: number) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (accept) => {
      if (accept) {
        try {
          setKontrakSub(kontrakSub.filter((item: any, _index) => _index != index))
          if (item.id) {
            setSIPItems([
              ...SIPItems,
              {
                ...item,
                plant: null,
                plant_desc: null,
                sloc: null,
                sloc_description: null,
                price: item.fixed_price,
                quantum: item.fixed_quantum - item.quantum_contract,
              },
            ])
          }
        } catch (error) {
          swal({
            title: `Failed`,
            icon: 'error',
            dangerMode: true,
          })
        }
      }
    })
  }

  const adddToContractItem = (itemChecked: number[]) => {
    setKontrakSub([
      ...kontrakSub,
      ...SIPItems.filter((item: any) => itemChecked.includes(item.id)).map((item: any) => {
        item.is_new_item = !item.order_sub_item_id
        item.quantum = !item.order_sub_item_id ? item.fixed_quantum : (item.fixed_quantum - (item.quantum_contract || 0)) 
        item.price = item.fixed_price
        item.price_before_ppn = countTotalPrice(item, false)
        item.price_after_ppn = countTotalPrice(item, true)
        return item
      }),
    ])
    setSIPItems(SIPItems.filter((item: any) => !itemChecked.includes(item.id)))
  }

  const addNewProduct = (item: any) => {
    setKontrakSub([
      ...kontrakSub,
      {
        ... item,
        price_before_ppn: countTotalPrice(item, false),
        price_after_ppn: countTotalPrice(item, true)
      }
    ])
  }

  const editIContractItem = (item_edited: any) => {
    setKontrakSub([
      ...kontrakSub.map((item: any, index) => {
        if (index == item_edited?.index) {
          delete item_edited?.index
          return {
            ...item_edited,
            price_before_ppn: countTotalPrice(item_edited, false),
            price_after_ppn: countTotalPrice(item_edited, true),
          }
        } else {
          return item
        }
      }),
    ])
  }

  const storeAttachmentNewProduct = (attachments: any[], _index: number) => {
    setKontrakSub([
      ...kontrakSub.map((item: any, index) => {
        if (index == _index) {
          return {
            ... item,
            attachments
          }
        } else {
          return item
        }
      }),
    ])
  }

  const storeScheduleNewProduct = (schedules: any[], _index : number) => {
    setKontrakSub([
      ...kontrakSub.map((item: any, index) => {
        if (index == _index) {
          return {
            ... item,
            schedules
          }
        } else {
          return item
        }
      }),
    ])
  }

  const countTotalPrice = (item: any, withPPN: boolean): any => {
    if (withPPN) {
      return (
        item.quantum * (item.price + (item.price / 100) * item.ppn) -
        ((item.quantum * (item.price + (item.price / 100) * item.ppn)) /
          ((item.ppn + 100) / 100) /
          100) *
          0
      )
    } else {
      return item.quantum * item.price
    }
  }

  const getSalesArea = async () => {
    await getSalesAreaKontrak(distChanel, salesOrg).then((res: any) => {
      setSalesArea(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office.slice(-2),
            label: item.description,
          }
        })
      )
    })
  }

  const getListCustomer = async () => {
    setCustomerLoad(true)
    setCustomerShipCode('')
    setCustomerShipName('')

    await getCustomer(salesOrg, distChanel, '', '')
      .then((res: any) => {
        setCustomerList(res.data.data.data)
        setNumberURLCustomerList(res.data.data.links)
        setShowCustomerList(true)
      })
      .finally(() => {
        setCustomerLoad(false)
      })
      .catch((error) => {
        swal({
          title: 'Failed!',
          icon: 'error',
        })
      })
  }

  const changePageCustomer = async (number: any) => {
    const customer_code = customerFilter?.customer_code ?? ''
    const name = customerFilter?.name ?? ''

    const res = await axios.get(
      `${number}&sales_org_code=${salesOrg}&customer_code=${customer_code}&name=${name}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setCustomerList(res.data.data.data)
    setNumberURLCustomerList(res.data.data.links)
  }

  const separator = (value: any, state1: any, state2: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
  }

  const getCountry = async () => {
    await getCountryList().then((res: any) => {
      setCountryList(
        res.data.data.map((item: any) => {
          return {
            value: item.code + '~#~' + item.name,
            label: item.name,
          }
        })
      )
    })
  }

  const getAllProvince = async () => {
    await getProvince3().then((res) => {
      setProvinceList(
        res.data.data.map((item: any) => {
          return {
            value: item.sales_office.slice(-2) + '~#~' + item.controlling_area,
            label: item.controlling_area,
          }
        })
      )
    })
  }

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  const getFooter = async () => {
    await getFooterContent(salesOrg, 'contract').then((res: any) => {
      setFooter(res.data.data)
    })
  }

  useEffect(() => {
    const getData = setTimeout(async () => {
      const customer_code = customerFilter?.customer_code ?? ''
      const name = customerFilter?.name ?? ''

      await getCustomer(salesOrg, distChanel, customer_code, name).then((res: any) => {
        setCustomerList(res.data.data.data)
        setNumberURLCustomerList(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [customerFilter])

  CustomUseEffect(() => {
    getSIPDetail()
    getSalesArea()
    getCountry()
    getAllProvince()
    getFooter()
  }, [detail])

  CustomUseEffect(() => {
    const getCity = async () => {
      await getFilterCity(sales_office).then((res: any) => {
        setCityKontrak(
          res.data.data.map((item: any) => {
            return {
              value: item.id,
              label: item.value,
            }
          })
        )
      })
    }
    getCity()
  }, [sales_office])

  const lang = i18next.language

  useEffect(() => {
    const getInco = async () => {
      const res = await getIncoterm()
      const data = res.data.data.data

      setFullIncoterm(
        res.data.data.map((item: any) => {
          return {
            value: item.id,
            label: item.code,
          }
        })
      )
    }

    getInco()
  }, [])

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
  }

  useEffect(() => {
    let totalPricee = kontrakSub.reduce((a: any, b: any) => a + (b['price_after_ppn'] || 0), 0)
    setFixedPrice(totalPricee)
    setBeforePpn(kontrakSub.reduce((acc: any, item: any) => acc + item.price_before_ppn, 0))
    setQuantumApprove(
      kontrakSub.filter((item: any) => (item?.product_type_desc != 'KANTONG/SACK' || item?.product_type != "8105")
    ).reduce((acc: any, item: any) => acc + item.quantum, 0))
    setSackApprove(
      kontrakSub.filter((item: any) => (item?.product_type_desc == 'KANTONG/SACK' || item?.product_type == "8105")
    ).reduce((acc: any, item: any) => acc + item.quantum, 0))
    setSackUnit(kontrakSub?.[0]?.unit)
  }, [kontrakSub])

  const editKontrak = async () => {
    swal({
      title: `${t('apakahAndaYakin create Contract')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (ok) => {
        if (ok) {
          setLoadingSubmit(true)
          resubmitContract(detail.id, {
              sip_order_id: detail.sip_order_id,
              customer: detail.customer_id,
              sales_office: sales_office,
              sales_group: cityData,
              validity_date_from: validateFrom,
              validity_date_to: validateTo,
              total_quantum: quantumApprove,
              total_price: beforePpn,
              grand_total: fixedPrice,
              assigner_name: assignerName,
              assigner_position: assignerPos,
              incoterm1: incoterm,
              incoterm2: incoterm2,
              doc_is_inc_ppn: doc_is_inc_ppn,
              province: province,
              province_desc: province_desc,
              country_destination: countryDesc,
              country_destination_code: countryId,
              customer_ship_to: customerShipCode,
              lang: lang,
              perihal: detail.perihal || '',
              order_sub_details: kontrakSub.map((item: any) => getPayloadItem(item)),
              ... additionalText
          }, localStorage.getItem('credential'))
          .then((res) => {
            swal({
              title: `${t('contract resubmit successfully')}`,
              icon: 'success',
            }).then(() => {
              navigate(`/management/kontrak`)
            })
          })
          .catch((err) => {
            swal({
              title: t(err.response?.data?.message),
              icon: 'error',
            })
          })
          .finally(() => {
            setLoadingSubmit(false)
          })
        }
      })
      .catch((err) => {})
  }

  const getPayloadItem = (item: any) => {
    return {
      incoterm1_id: item.incoterm1_id,
      incoterm2_id: item.incoterm2_id,
      sales_org_code: item.sales_org_code,
      sector_id: item.sector_id,
      id: (item.sip_item_id || item.id) || undefined,
      plant: item.plant,
      plant_desc: item.plant_desc,
      plant_desc_en: item.plant_desc_en,
      sloc: item.sloc,
      sloc_description: item.sloc_description,
      product_type: item.product_type,
      product_type_desc: item.product_type_desc,
      product_name: item.product_name,
      material_number: item.material_number,
      material_desc_en: item.material_desc_en,
      unit: item.unit,
      product_spec: item.product_spec,
      fixed_quantum: item.quantum,
      fixed_price: item.price,
      city_id: item.city_id || undefined,
      province_id: item.province_id,
      end_user: item.end_user,
      end_user_multiple: item.end_user_multiple,
      notes: item.notes,
      payment_type_1: item.payment_type_1,
      payment_type_1_desc: item.payment_type_1_desc,
      payment_type_2: item.payment_type_2,
      payment_type_2_desc: item.payment_type_2_desc,
      payment_note: item.payment_note,
      segment_code: item.segment_code,
      segment_name: item.segment_name,
      shipping_tolerance: item.shipping_tolerance,
      include_ppn: item.include_ppn,
      shipping_tolerance_contract: item.shipping_tolerance_contract,
      schedules: item.schedules || undefined,
      attachments: item.attachments ? item.attachments.map((file: any) => {
        return {
          ... file,
          file_r: file.file_r ? (file.file_r.split(',')[1] || '') : ''
        }
      }) : undefined,
    }
  }

  const letterData = {
    lang: i18next.language,
    sector: sektorid ? sektorid : '',
    customer: cusTitle ? cusTitle + ' ' + cusName : cusName,
    anper: kontrakSub.length > 0
      ? kontrakSub[0]?.produsen?.name || kontrakSub[0]?.sales_org_code_desc
      : '',
    address: detail?.customer?.address,
    city: detail?.customer?.city,
    region: detail?.customer?.province,
    customerAttn: lang == 'en' ? (additionalText.customer_attn_en || (additionalText.customer_attn || '')) : (additionalText.customer_attn || ''),
    mail: lang == 'en' ? (additionalText.mail_body_en || (additionalText.mail_body || '')) : (additionalText.mail_body || ''),
    terms: lang == 'en' ? (additionalText.terms_and_conditions_en || (additionalText.terms_and_conditions || '')) : (additionalText.terms_and_conditions || ''),
    title: lang == 'en' ? (additionalText.title_en || (additionalText.title || '')) : (additionalText.title || ''),
    dateFrom: validateFrom ? validateFrom : '',
    dateTo: validateTo ? validateTo : '',
    port: lang == 'en' ? (additionalText.port_of_discharge_en || (additionalText.port_of_discharge || '')) : (additionalText.port_of_discharge || ''),
    lain_lain: lang == 'en' ? (additionalText.lain_lain_en || (additionalText.lain_lain || '')) : (additionalText.lain_lain || ''),
    keterangan: lang == 'en' ? (additionalText.keterangan_en || (additionalText.keterangan || '')) : (additionalText.keterangan || ''),
    textPenutup: lang == 'en' ? (additionalText.text_penutup_en || (additionalText.text_penutup || '')) : (additionalText.text_penutup || ''),
    configletter: footer ? (i18next.language == 'id' ? (footer?.indonesia?.content || '') : (footer?.english?.content || '')) : '',
    subItem: kontrakSub,
    signername: assignerName ? assignerName : '',
    singerposition: assignerPos ? assignerPos : '',
    cusName: additionalText.customer_pic_name ? additionalText.customer_pic_name : '',
    cusPos: additionalText.customer_pic_position ? additionalText.customer_pic_position : '',
    include: doc_is_inc_ppn,
    payloadharga: kontrakSub.map((item: any) => item.price),
    payloadquantum: kontrakSub.map((item: any) => item.quantum),
    imgHeader: imgHeader ? imgHeader?.url_file : '',
    imgFooter: imgFooter ? imgFooter?.url_file : '',
    payloadspec: kontrakSub.map((item: any) => item.product_spec),
    pph22: PPh22,
    segment: kontrakSub.length > 0
    ? kontrakSub[0]?.segment_name : '',
    incoterm1: fullIncoterm.find((item: any) => item.value == incoterm)?.label,
    incoterm2: incoterm2,
    sapNumber: detail?.sap_number,
    approvedDate: detail?.release_date,
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {t('page edit contract')}
      </PageTitle>
      <div className='card p-5'>
        <div className='card-body'>
          {!loadingPage ? (
            <>
              <Row>
                <Col md={6}>
                  <Row className='mb-3'>
                    <Col lg={5}>
                      <p className='fs-4 mt-2'>{t('SIP ID')}</p>
                    </Col>
                    <Col lg={7}>
                      <Form.Control
                        type='text'
                        placeholder={t('SIP ID')}
                        value={`11${detail?.sip_order.SIP_number}`}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>{t('Customer Name')}</p>
                    </Col>
                    <Col lg={7}>
                      {detail != null ? (
                        <Form.Control type='text' value={detail.customer.name} disabled size='sm' />
                      ) : (
                        <Form.Control
                          type='text'
                          placeholder={t('Customer Name')}
                          disabled
                          size='sm'
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className='mb-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        type='text'
                        value={detail?.customer?.customer_code}
                        disabled
                        size='sm'
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>{t('Address')}</p>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        as='textarea'
                        value={detail?.customer?.address}
                        disabled
                        style={{height: '40px'}}
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              {/* <hr /> */}

              <Row>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        Incoterm<span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Select
                        placeholder='Incoterm'
                        key={cusName}
                        value={fullIncoterm.find((x) => x.value == incoterm)}
                        onChange={(e: any) => setIncoterm(e?.value)}
                        options={fullIncoterm}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        Incoterm 2<span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Form.Control
                        id='inco2'
                        type='text'
                        placeholder='Incoterm 2'
                        value={incoterm2}
                        onChange={(e: any) => setIncoterm2(e.target.value)}
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        {t('negara')}
                        {/* <span className='text-danger'>*</span> */}
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Select
                        placeholder={t('negara')}
                        key={cusName}
                        onChange={(e: any) => {
                          separator(e?.value, setCountryId, setCountryDesc)
                          setProvince('')
                          setProvinceDesc('')
                        }}
                        options={countryList}
                        value={countryList.find((x) => x.value == `${countryId};${countryDesc}`)}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        {t('provinsi-tujuan')}
                        {/* <span className='text-danger'>*</span> */}
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Select
                        placeholder={t('provinsi-tujuan')}
                        key={cusName}
                        onChange={(e: any) => separator(e?.value, setProvince, setProvinceDesc)}
                        isDisabled={countryDesc != 'Indonesia' && countryDesc != '' ? true : false}
                        options={provinceList}
                        value={provinceList.find((x) => x.value == `${province};${province_desc}`)}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        Sales Office
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Select
                        placeholder='Sales Office'
                        key={cusName}
                        onChange={(e: any) => {
                          setSalesOffice(e?.value)
                          setCityData('')
                        }}
                        options={salesArea}
                        value={salesArea.find((x) => x.value == sales_office)}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        Sales Group
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Select
                        key={cusName + sales_office}
                        placeholder='Sales Group'
                        onChange={(e: any) => setCityData(e?.value)}
                        options={cityKontrak}
                        value={cityKontrak.find((x) => x.value == cityData)}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        {t('order-tanggal-dari')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <input
                        type='date'
                        defaultValue={validateFrom}
                        onChange={(e: any) => setValidateFrom(e.target.value)}
                        className='form-control form-control-sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        {t('order-tanggal-berakhir')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <input
                        type='date'
                        defaultValue={validateTo}
                        onChange={(e: any) => setValidateTo(e.target.value)}
                        className='form-control form-control-sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        {t('Assigner Name')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Form.Control
                        id='assignerName'
                        type='text'
                        onChange={(e: any) => setassignerName(e.target.value)}
                        value={assignerName}
                        placeholder={t('Assigner Name')}
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>
                        {t('Assigner Position')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Form.Control
                        id='assignerPos'
                        type='text'
                        onChange={(e: any) => setassignerPos(e.target.value)}
                        value={assignerPos}
                        placeholder={t('Assigner Position')}
                        size='sm'
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col md={6}>
                  <Row>
                    <Col lg={5}>
                      <p className='fs-4 mt-3'>{t('Ship To')}</p>
                    </Col>
                    <Col lg={7}>
                      <div className='d-flex'>
                        <Form.Control
                          className='me-1'
                          id='assignerName'
                          type='text'
                          disabled
                          value={
                            customerShipCode ? `${customerShipCode} - ${customerShipName}` : ''
                          }
                          placeholder={t('Ship To')}
                          size='sm'
                        />
                        <Button
                          className='btn btn-primary d-flex justify-content-center align-items-center'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('telusuri')}
                          onClick={getListCustomer}
                          disabled={detail && !customerLoad ? false : true}
                          size='sm'
                        >
                          {customerLoad ? (
                            <span className='spinner-border spinner-border-sm align-middle'></span>
                          ) : (
                            <KTSVG
                              path='/media/icons/duotune/browse.svg'
                              className='svg-icon-3 ms-2'
                            />
                          )}
                        </Button>

                        <Modal
                          show={showCustomerList}
                          onHide={() => setShowCustomerList(false)}
                          centered
                          size='lg'
                          backdrop='static'
                          keyboard={false}
                          scrollable
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{t('Browse')}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <TableBrowseCustomer
                              customerList={customerList}
                              paginateNumber={changePageCustomer}
                              numberURL={numberURLCustomerList}
                              onSelectCustomer={(item: any) => {
                                setCustomerShipCode(item.customer_code)
                                setCustomerShipName(item.name)
                                setShowCustomerList(false)
                              }}
                            />
                          </Modal.Body>
                        </Modal>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col sm={5}>
                      <p className='fs-4 mt-3'>{t('termasuk-ppn')}</p>
                    </Col>
                    <Col sm={7} className='d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='ppn'
                        className='mt-5 mb-2'
                        type='checkbox'
                        id='ckbox-ppn'
                        defaultChecked={doc_is_inc_ppn}
                        onClick={() => setDocIsIncPpn(!doc_is_inc_ppn)}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className='d-flex justify-content-start mt-8'>
                <ModalAddItem items={SIPItems} onAddItemSelected={adddToContractItem} />
                {kontrakSub.filter((item) => (item.id)).length > 0 && (
                  <ModalAddProduct onAdd={addNewProduct} data={{
                    sector: detail.sector,
                    sales_org: detail.anper,
                    incoterm1: kontrakSub[0]?.incoterm1?.code,
                    incoterm1_id: kontrakSub[0]?.incoterm1_id,
                    incoterm2: kontrakSub[0]?.incoterm2?.code || kontrakSub[0]?.incoterm2_id,
                    payment_type1: kontrakSub[0]?.payment_type_1,
                    payment_type_desc1: kontrakSub[0]?.payment_type_1_desc,
                    payment_type2: kontrakSub[0]?.payment_type_2,
                    payment_type_desc2: kontrakSub[0]?.payment_type_2_desc,
                    ppn: kontrakSub[0]?.ppn,
                    distChanel: distChanel
                  }} />
                )}
                <AdditionalTextModal data={detail} onStoreTexts={(text) => {
                  setAdditionalText(text)
                  setDetail({... detail, ... text})
                }} />
                <Button 
                  onClick={() => {
                    setShowLetter(true)
                  }}
                  className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title={t('preview')}
                >
                  {t('preview')}
                </Button>
                <Modal
                  show={showLetter}
                  onHide={() => setShowLetter(false)}
                  size='xl'
                  backdrop='static'
                  keyboard={false}
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{t('preview')}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <ViewLetter data={letterData} type='kontrak' />
                  </Modal.Body>
              </Modal>

              <Button
                variant='primary'
                className="ms-2"
                onClick={() => {
                  setShowUpload(true)
                  setAttachmentType('contract')
                  setSubOrderID(ContractID || '')
                }}
              >
                {t('order-lampiran')}
              </Button>
              </div>

              <div className='table-responsive mt-5 bdr' style={{marginBottom: '3rem'}}>
                {/* Table Head */}
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                      <th className='td-order-1 text-center'>{t('kontrak-item')}</th>
                      <th className='td-order-4 text-center'>{t('kontrak-aksi')}</th>
                      <th className='td-order-2 text-center'>Sales Org</th>
                      <th className='td-order-2 text-center'>{t('kontrak-incoterm')} </th>
                      {sektorid != 3 && (
                        <th className='td-order-2 text-center'>{t('kontrak-wilayah')}</th>
                      )}
                      {sektorid == 1 && <th className='td-order-2 text-center'>{t('segment')}</th>}
                      <th className='td-order-3 text-center'>{t('sub-order-endUser')}</th>
                      <th className='td-order-3 text-center'>{t('Sector')} </th>
                      <th className='td-order-2 text-center'>{t('kontrak-jenis')} </th>
                      <th className='td-order-2 text-center'>{t('Product Code')} </th>
                      <th className='td-order-2 text-center'>{t('kontrak-nama')} </th>
                      <th className='td-order-2 text-center'>{t('kontrak-spek')}</th>
                      <th className='td-order-2 text-center'>{t('kontrak-kuantum')}</th>
                      <th className='td-order-2 text-center'>{t('kontrak-harga')}</th>
                      {/* <th className='td-order-2 text-center'>Status {t('Price')}</th> */}
                      {/* <th className='td-order-2 text-center'>Price</th> */}
                      <th className='td-order-2 text-center'>{t('kontrak-hargaPPN')}</th>
                      <th className='td-order-2 text-center'>{t('kontrak-ppn')}</th>
                      <th className='td-order-2 text-center'>{t('kontrak-hargaSPPN')}</th>
                      {sektorid == 2 ? (
                        <th className='td-order-2 text-center'>{t('kontrak-Gudang')} </th>
                      ) : (
                        ''
                      )}
                    </tr>
                  </thead>
                  {detail != null ? (
                    <tbody>
                      {kontrakSub.map((detailss: any, index: number) => {
                        return (
                          <tr
                            key={index}
                            className='d-flex jusify-content-center w-100 align-items-center'
                          >
                            <td className='td-order-1 text-center columnFlex'>{index + 1}</td>
                            <td className='td-order-4 columnFlex'>
                              <div className='d-flex' style={{gap: 2}}>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title='Detail'
                                  onClick={handleShow}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <Modal
                                  show={show}
                                  onHide={handleClose}
                                  centered
                                  scrollable
                                  size='xl'
                                  backdrop='static'
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title>Detail</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    {detailss?.sector_id == 1 && (
                                      <Row>
                                        <Col md='6'>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>Sales Org</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.produsen?.name}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>
                                                {t('sub-order-incoterm1')}
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.incoterm1?.code}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                type='text'
                                                value={detailss.province?.region_name}
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.product_type_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('Plant')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.plant_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseInt(
                                                        detailss?.fixed_quantum
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                    : parseInt(
                                                        detailss?.fixed_quantum
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col sm={4}>
                                              <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                            </Col>
                                            <Col sm={8}>
                                              <InputGroup>
                                                <Form.Control
                                                  placeholder={t('Shipping Tolerance')}
                                                  size='sm'
                                                  type='text'
                                                  id='shipping'
                                                  value={detailss?.shipping_tolerance + '%'}
                                                  disabled
                                                />
                                                <InputGroup.Text>%</InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.payment_type_1_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='fs-6'>{t('keterangan')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={t(detailss?.payment_note)}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('segment')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                type='text'
                                                value={t(detailss.segment_name)}
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  detailss.end_user_detail?.name
                                                    ? detailss.end_user_detail?.name
                                                    : detailss.end_user
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                        <Col md='6'>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={t(detailss.sector?.name)}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>
                                                {t('sub-order-incoterm2')}
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              {detailss?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    detailss?.incoterm2_id == null ||
                                                    detailss?.incoterm2_id == '0'
                                                      ? ''
                                                      : detailss?.incoterm2_id
                                                  }
                                                  type='text'
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={detailss?.incoterm2?.code}
                                                  type='text'
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                type='text'
                                                value={detailss.city?.city_name}
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.product_name}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4} className='d-flex align-items-center'>
                                              <p className='fs-6'>{t('sub-order-spek')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <FieldProductSpec
                                                data={detailss.product_spec}
                                                type='editor'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-2'>
                                            <Col md={4}>
                                              <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  'Rp' + i18next.language === 'en'
                                                    ? parseInt(
                                                        detailss?.fixed_price
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : parseInt(
                                                        detailss?.fixed_price
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-5'>
                                            <Col sm={4}>
                                              <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                            </Col>
                                            <Col sm={8} className='d-flex justify-content-start'>
                                              <Form.Check
                                                reverse
                                                name='ppn'
                                                className='mt-4 mb-2'
                                                type='checkbox'
                                                id='ckbox-ppn'
                                                checked={detailss?.include_ppn}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.payment_type_2_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.notes}
                                                as='textarea'
                                                style={{height: '40px'}}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    )}

                                    {detailss?.sector_id == 2 && (
                                      <Row>
                                        <Col md='6'>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>Sales Org</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.produsen?.name}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>
                                                {t('sub-order-incoterm1')}
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.incoterm1?.code}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                type='text'
                                                value={detailss.province?.region_name}
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.plant_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.product_name}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseInt(
                                                        detailss?.fixed_quantum
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                    : parseInt(
                                                        detailss?.fixed_quantum
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' Ton'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.payment_type_1_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='fs-6'>{t('keterangan')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={t(detailss?.payment_note)}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  detailss.end_user_detail?.name
                                                    ? detailss.end_user_detail?.name
                                                    : detailss.end_user
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                        <Col md='6'>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={t(detailss.sector?.name)}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>
                                                {t('sub-order-incoterm2')}
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              {detailss?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    detailss?.incoterm2_id == null ||
                                                    detailss?.incoterm2_id == '0'
                                                      ? ''
                                                      : detailss?.incoterm2_id
                                                  }
                                                  type='text'
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={detailss?.incoterm2?.code}
                                                  type='text'
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                type='text'
                                                value={detailss.city?.city_name}
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.product_type_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4} className='d-flex align-items-center'>
                                              <p className='fs-6'>{t('sub-order-spek')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <FieldProductSpec
                                                data={detailss.product_spec}
                                                type='editor'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='fs-6 mt-3'>
                                                {t('sub-order-hargaD')}/Ton
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  'Rp' + i18next.language === 'en'
                                                    ? parseInt(
                                                        detailss?.fixed_price
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : parseInt(
                                                        detailss?.fixed_price
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.payment_type_2_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.notes}
                                                as='textarea'
                                                style={{height: '40px'}}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    )}

                                    {detailss?.sector_id == 3 && (
                                      <Row>
                                        <Col md='6'>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>Sales Org</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.produsen?.name}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>
                                                {t('sub-order-incoterm1')}
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.incoterm1?.code}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.product_type_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('Plant')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.plant_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  i18next.language === 'en'
                                                    ? parseInt(
                                                        detailss?.fixed_quantum
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' MT'
                                                    : parseInt(
                                                        detailss?.fixed_quantum
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      }) + ' MT'
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col sm={4}>
                                              <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                            </Col>
                                            <Col sm={8}>
                                              <InputGroup>
                                                <Form.Control
                                                  placeholder={t('Shipping Tolerance')}
                                                  size='sm'
                                                  type='text'
                                                  id='shipping'
                                                  value={detailss?.shipping_tolerance + '%'}
                                                  disabled
                                                />
                                                <InputGroup.Text>%</InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.payment_type_1_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='fs-6'>{t('keterangan')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={t(detailss?.payment_note)}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  detailss.end_user_detail?.name
                                                    ? detailss.end_user_detail?.name
                                                    : detailss.end_user
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                        <Col md='6'>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={t(detailss.sector?.name)}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>
                                                {t('sub-order-incoterm2')}
                                              </p>
                                            </Col>
                                            <Col md={8}>
                                              {detailss?.incoterm2 == null ? (
                                                <Form.Control
                                                  value={
                                                    detailss?.incoterm2_id == null ||
                                                    detailss?.incoterm2_id == '0'
                                                      ? ''
                                                      : detailss?.incoterm2_id
                                                  }
                                                  type='text'
                                                  disabled
                                                  size='sm'
                                                />
                                              ) : (
                                                <Form.Control
                                                  value={detailss?.incoterm2?.code}
                                                  type='text'
                                                  disabled
                                                  size='sm'
                                                />
                                              )}
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss.product_name}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4} className='d-flex align-items-center'>
                                              <p className='fs-6'>{t('sub-order-spek')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <FieldProductSpec
                                                data={detailss.product_spec}
                                                type='editor'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-2'>
                                            <Col md={4}>
                                              <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={
                                                  'USD' + i18next.language === 'en'
                                                    ? parseInt(
                                                        detailss?.fixed_price
                                                      ).toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                    : parseInt(
                                                        detailss?.fixed_price
                                                      ).toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                      })
                                                }
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          {/* <Row className='mb-5'>
                                            <Col sm={4}>
                                              <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                            </Col>
                                            <Col sm={8} className='d-flex justify-content-start'>
                                              <Form.Check
                                                reverse
                                                name='ppn'
                                                className='mt-4 mb-2'
                                                type='checkbox'
                                                id='ckbox-ppn'
                                                checked={detailss?.include_ppn}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                value={detailss?.payment_type_2_desc}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                          <Row className='mb-4'>
                                            <Col md={4}>
                                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                            </Col>
                                            <Col md={8}>
                                              <Form.Control
                                                as='textarea'
                                                style={{height: '40px'}}
                                                value={detailss?.notes}
                                                type='text'
                                                disabled
                                                size='sm'
                                              />
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    )}
                                  </Modal.Body>
                                </Modal>

                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('order-lampiran')}
                                  onClick={() => {
                                    setShowUpload(true)
                                    detailss.index = index
                                    setItemEditing(detailss)
                                    setAttachmentType('order-item')
                                    setSubOrderID(detailss.order_sub_item_id || detailss.id)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/archive-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>

                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Jadwal')}
                                  onClick={() => {
                                    setIDSector(detailss.sector_id)
                                    setProvinceName(detailss.province?.region_name)
                                    setCityName(detailss.city?.city_name)
                                    setProductName(detailss.product_name)
                                    formattingTon(detailss.fixed_quantum)
                                    if (detailss.is_new_item) {
                                      detailss.index = index
                                      setItemEditing(detailss)
                                      setShowJadwal2(true)
                                    } else {
                                      setJadwalID(detailss.order_sub_item_id)
                                      setShowJadwal(true)
                                    }
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <Modal
                                  show={showJadwal}
                                  onHide={() => {
                                    setShowJadwal(false)
                                    setJadwalID('')
                                  }}
                                  centered
                                  size='xl'
                                  backdrop='static'
                                  keyboard={false}
                                  scrollable
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title>
                                      {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                                      {productName} | {fixedQuantum} Ton
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <AddRemoveJadwal id={jadwalID} is_amendment={'false'} />
                                  </Modal.Body>
                                </Modal>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('ubah')}
                                  onClick={() => {
                                    setShowEdit(true)
                                    detailss.index = index
                                    setItemEditing(detailss)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/pencil-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>

                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                  onClick={() => removeItem(detailss, index)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </div>
                            </td>
                            <td className='td-order-2 text-center columnFlex'>
                              {detailss.produsen.name}
                            </td>
                            {detailss.incoterm2 != null ? (
                              <td className='td-order-2 text-center columnFlex'>
                                <PopoverText
                                  content={detailss.incoterm1.code + '-' + detailss.incoterm2.code}
                                  index={index}
                                  className='spec-sliceee'
                                />
                              </td>
                            ) : (
                              <>
                                {detailss.incoterm2_id == null || detailss.incoterm2_id == '0' ? (
                                  <td className='td-order-2 text-center columnFlex'>
                                    {detailss.incoterm1.code}
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center columnFlex'>
                                    <PopoverText
                                      content={
                                        detailss.incoterm1.code + '-' + detailss.incoterm2_id
                                      }
                                      index={index}
                                      className='spec-sliceee'
                                    />
                                  </td>
                                )}
                              </>
                            )}
                            {sektorid != 3 && (
                              <td className='td-order-2 text-center columnFlex'>
                                {detailss?.province?.region_name} {detailss.city?.city_name}
                              </td>
                            )}
                            {sektorid == 1 && (
                              <td className='td-order-2 text-center columnFlex'>
                                {t(detailss.segment_name)}
                              </td>
                            )}
                            <td className='td-order-3 text-center columnFlex'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    detailss?.end_user_detail?.name
                                      ? detailss.end_user_detail?.name
                                      : detailss.end_user
                                  }
                                  index={index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                            <td className='td-order-3 text-center columnFlex'>
                              {t(detailss?.sector?.name)}
                            </td>
                            <td className='td-order-2 text-center columnFlex'>
                              {detailss?.product_type_desc}
                            </td>
                            <td className='td-order-2 text-center columnFlex'>
                              <p>
                                {parseInt(detailss.material_number) == 0
                                  ? ''
                                  : detailss.material_number?.slice(-7)}
                              </p>
                            </td>
                            <td className='td-order-2 text-center columnFlex'>
                              {detailss.product_name}
                            </td>
                            <td className='td-order-2 text-center columnFlex'>
                              <PopoverText
                                content={detailss.product_spec || '-'}
                                index={index}
                                className='spec-slice'
                              />
                            </td>
                            <td className='td-order-2 text-center columnFlex'>
                              {i18next.language === 'en'
                                ? detailss.quantum?.toLocaleString('en', {
                                    maximumFractionDigits: 4,
                                  })
                                : detailss.quantum?.toLocaleString('id', {
                                    maximumFractionDigits: 4,
                                  })}{' '}
                              {detailss.sector_id === 3 ? 'MT' : 'Ton'}
                            </td>
                            {/* <td className='td-order-2 text-center columnFlex'>
                                  {detailss.request_price.toLocaleString()}/1
                                </td> */}
                            <td className='td-order-2 text-center columnFlex'>
                              {(sektorid != 3 ? 'Rp' : 'USD') +
                                (i18next.language === 'en'
                                  ? detailss.price?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : detailss.price?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) +
                                (sektorid != 3 ? '/Ton' : '/MT')}
                            </td>
                            {/* <td className='td-order-2 text-center columnFlex'>{detailss.include_ppn ? 'Include PPN' : 'Exclude PPN'}</td> */}
                            <td className='td-order-2 text-center columnFlex'>
                              {(sektorid == 3 ? 'USD ' : 'Rp ') +
                                detailss.price_before_ppn?.toLocaleString(
                                  i18next.language === 'en' ? 'en' : 'id',
                                  {maximumFractionDigits: 0}
                                )}
                            </td>
                            <td className='td-order-2 text-center columnFlex'>{detailss.ppn}%</td>
                            <td className='td-order-2 text-center columnFlex'>
                              {(sektorid == 3 ? 'USD ' : 'Rp ') +
                                detailss.price_after_ppn?.toLocaleString(
                                  i18next.language === 'en' ? 'en' : 'id',
                                  {maximumFractionDigits: 0}
                                )}
                            </td>

                            {/* <td className='td-order-2 text-center columnFlex'>
                                  {detailss.request_quantum.toLocaleString()}
                                </td> */}
                            {detailss?.sector_id == 2 ? (
                              <td className='td-order-2 text-center columnFlex'>
                                {detailss?.plant_desc}
                              </td>
                            ) : (
                              ''
                            )}
                          </tr>
                        )
                      })}
                    </tbody>
                  ) : null}
                </table>
                {/* End Table Head */}
              </div>

              {detail && (
                <div style={{width: '50%'}}>
                  <Row className='mb-3'>
                    <Col lg={4}>
                      <p className='fs-4 mt-3'>Total {t('Quantum')}</p>
                    </Col>
                    <Col lg={8}>
                      <Form.Control
                        id='totalquantum'
                        type='text'
                        aria-label='Default select example'
                        placeholder={'Total ' + t('Quantum')}
                        value={
                          (i18next.language === 'en'
                            ? quantumApprove?.toLocaleString('en', {maximumFractionDigits: 4})
                            : quantumApprove?.toLocaleString('id', {maximumFractionDigits: 4})) +
                          ' ' +
                          'Ton'
                        }
                        disabled
                      />
                    </Col>
                  </Row>

                  <Row className='mb-3' hidden={sackApprove ? false : true}>
                    <Col lg={4}>
                      <p className='fs-4 mt-3'>Total {t('sack')}</p>
                    </Col>
                    <Col lg={8}>
                      <Form.Control
                        id='totalquantum'
                        type='text'
                        aria-label='Default select example'
                        placeholder={'Total ' + t('sack')}
                        value={
                          (i18next.language === 'en'
                            ? sackApprove?.toLocaleString('en', {maximumFractionDigits: 4})
                            : sackApprove?.toLocaleString('id', {maximumFractionDigits: 4})) +
                          ' ' +
                          sackUnit
                        }
                        disabled
                      />
                    </Col>
                  </Row>

                  <Row className='mb-3'>
                    <Col lg={4}>
                      <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                    </Col>
                    <Col lg={8}>
                      <Form.Control
                        id='totalprice'
                        type='text'
                        aria-label='Default select example'
                        placeholder={'Total ' + t('Exclude') + ' PPN'}
                        value={
                          (sektorid != 3 ? 'Rp' : 'USD') +
                          (i18next.language === 'en'
                            ? beforePpn?.toLocaleString('en', {maximumFractionDigits: 4})
                            : beforePpn?.toLocaleString('id', {maximumFractionDigits: 4}))
                        }
                        disabled
                      />
                    </Col>
                  </Row>

                  <Row className='mb-3'>
                    <Col lg={4}>
                      <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                    </Col>
                    <Col lg={8}>
                      <Form.Control
                        type='text'
                        id='total'
                        aria-label='Default select example'
                        placeholder={'Total ' + t('Include') + ' PPN'}
                        value={
                          (sektorid != 3 ? 'Rp' : 'USD') +
                          (i18next.language === 'en'
                            ? fixedPrice?.toLocaleString('en', {maximumFractionDigits: 4})
                            : fixedPrice?.toLocaleString('id', {maximumFractionDigits: 4}))
                        }
                        disabled
                      />
                    </Col>
                  </Row>
                </div>
              )}

              <ModalEditItem
                onEdit={editIContractItem}
                item={itemEditing}
                show={showEdit}
                onCloseModal={() => setShowEdit(false)}
              />

              <AttachhmentModal 
                subOrderId={subOrderID}
                attachmentType={attachmentType}
                setAttachmentType={setAttachmentType}
                onStoreAttachmentNewProduct={storeAttachmentNewProduct} 
                item={itemEditing} 
                show={showUpload} 
                onCloseModal={() => {
                setShowUpload(false)
              setSubOrderID(null)}} 
              />

              <ScheduleModal 
                title={
                  (idSektor != 3 ? (provinceName + ', ' + cityName + ' | ') : '') + 
                  productName + ' | ' + fixedQuantum + (itemEditing?.product_type == '8105' ? ' EA' : ' Ton')
                }
                item={itemEditing} 
                show={showJadwal2} 
                onStoreSchedule={storeScheduleNewProduct}
                onCloseModal={() => setShowJadwal2(false)} 
              />

              <div className='d-flex justify-content-end mt-5'>
                <Link to={'/management/kontrak'}>
                  <Button className='btn btn-secondary me-2'>{t('order-kembali')}</Button>
                </Link>
                <Button className='btn btn-primary' onClick={editKontrak} disabled={btnLoading}>
                  {loadingSubmit ? (
                    <Spinner animation='border' variant='light' size='sm' />
                  ) : (
                    t('submit')
                  )}
                </Button>
              </div>
            </>
          ) : (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export {KontrakRevisi}
